module.exports = __webpack_public_path__ + "static/media/constant-temp-icon.77a6dce4.svg";